var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHasnotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 17C22.9853 17 25 14.9853 25 12.5C25 10.0147 22.9853 8 20.5 8C18.0147 8 16 10.0147 16 12.5C16 14.9853 18.0147 17 20.5 17Z",
    fill: "#FF5800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 19.8V21.3C14.7 22.3 13.9 23.1 12.9 23.1C11.9 23.1 11.1 22.3 11.1 21.3V19.8M16.4 6.10001C15.5 5.40001 14.7 5.20001 14.7 5.20001V4.8C14.7 3.8 13.9 3 12.9 3C11.9 3 11.1 3.8 11.1 4.8V5.20001C11.1 5.20001 7.89998 6.10001 7.09998 9.60001C6.29998 13.1 6.2 17.2 4 19.7H21.8",
    stroke: "#FF5800",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13.3333C20.2239 13.3333 20 13.1095 20 12.8333V10.5C20 10.2239 20.2239 10 20.5 10C20.7761 10 21 10.2239 21 10.5V12.8333C21 13.1095 20.7761 13.3333 20.5 13.3333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15C20.2239 15 20 14.7761 20 14.5C20 14.2239 20.2239 14 20.5 14C20.7761 14 21 14.2239 21 14.5C21 14.7761 20.7761 15 20.5 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHasnotification);
export default __webpack_public_path__ + "static/media/hasnotification.0b991674e792036ca69a5ea01831ad92.svg";
export { ForwardRef as ReactComponent };